import { create } from "zustand";

type CenterAlertType = "success" | "error" | "info" | "warning";

type OpenCenterAlertParams = {
  message: string;
  type?: CenterAlertType;
  actionLabel?: string;
  actionHref?: string;
};

type State = {
  isOpen: boolean;
  message: string;
  type: CenterAlertType;
  actionLabel?: string;
  actionHref?: string;
  openCenterAlert: (params: OpenCenterAlertParams) => void;
  closeCenterAlert: () => void;
};

export const useCenterNotificationStore = create<State>((set) => ({
  isOpen: false,
  message: "",
  type: "success",
  actionLabel: undefined,
  actionHref: undefined,

  openCenterAlert: ({ message, type = "success", actionLabel, actionHref }) =>
    set({
      isOpen: true,
      message,
      type,
      actionLabel,
      actionHref,
    }),

  closeCenterAlert: () =>
    set({
      isOpen: false,
      message: "",
      type: "success",
      actionLabel: undefined,
      actionHref: undefined,
    }),
}));
